<template>
  <label class="radio-label" :class="[type ? 'radio-label--' + type : '', simpleQuestion ? 'radio-label--simple-question' : '']">
    <input :name="name"
           :value="label"
           v-model="radioButtonValue"
           :disabled="disabled"
           type="radio"
           class="radio-input visually-hidden">
    <span class="radio-label__icon" :class="{'radio-label__icon--disabled': disabled}"></span>
    <span v-if="!isLabelHtml" class="radio-label__label" :class="{'radio-label__label--hidden': isLabelHidden, 'radio-label__label--fw-normal': normalFontWeight}">{{ label }}</span>
    <slot v-else/>
  </label>
</template>

<script>
export default {
  name: 'Radio',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: [String, Number],
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    },
    type: {
      type: String,
      default: ''
    },
    simpleQuestion: {
      type: Boolean,
      default: false
    },
    isLabelHidden: Boolean,
    normalFontWeight: Boolean,
    isLabelHtml: Boolean,
    disabled: Boolean
  },
  computed: {
    radioButtonValue: {
      get: function () {
        return this.value
      },
      set: function () {
        this.$emit('change', this.label)
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.radio-label
  position: relative
  user-select: none
  cursor: pointer
  margin: 5px
  display: block

  &--questionnaire
    margin: 0 0 4px

  &--simple-question
    display: flex
    margin: 0 0 20px

    +mmin($extsmall--hor)
      margin: 0 0 10px

.radio-label__icon
  position: absolute
  top: 0
  left: 0
  height: 20px
  width: 20px
  background-color: $page-bg
  border-radius: 50%
  border: 1px solid #cccccc
  display: block

  &--disabled
    border-color: $nd-border-color

.radio-label__icon:after
  content: ""
  position: absolute
  display: none
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  width: 8px
  height: 8px
  border-radius: 50%
  background-color: $main-color

input:hover ~ .radio-label__icon:not(.radio-label__icon--disabled),
input:focus ~ .radio-label__icon:not(.radio-label__icon--disabled)
  border-color: $placeholder-color

.radio-label__label
  color: rgba(0, 0, 0, .98)
  font-size: 14px
  font-weight: 400
  line-height: 20px
  margin-left: 30px
  margin-right: 5px

  &--hidden
    color: transparent

  &--fw-normal
    font-weight: 400

.radio-input:checked ~ .radio-label__icon:after
  display: block

</style>
